import { render, staticRenderFns } from "./PaymentMethodes.vue?vue&type=template&id=355e428f&"
import script from "./PaymentMethodes.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports